// import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Login from '../components/Login';

const LoginPage = () => {
  return (
    <div className="grid lg:grid-cols-2 lg:gap-6 w-full justify-center">
      <div className="hidden lg:block h-full max-h-screen py-8 sticky top-0">
        <div
          className="h-full w-full rounded-md overflow-hidden bg-cover flex flex-col justify-end"
          style={{ backgroundImage: 'url(/img/login.jpg)' }}
        ></div>
      </div>
      <div className="max-w-sm flex flex-col items-start justify-center min-h-screen mx-auto">
        <Header
          heading="Login to your account"
          paragraph="Enter your email below to login to your account. "
        />

        <Login />

        <p className="text-sm text-gray-500 text-center self-center mt-6">
          Don't have an account yet?{' '}
          <Link className="underline" to={`/signup${window.location.search}`}>
            Signup
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
